var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRecordAudio = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.937,
  d: "M5.154 3.562 2.345 7.399a.47.47 0 0 0 .047.608l.383.383a.47.47 0 0 0 .616.041l3.68-2.808"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.937,
  d: "M7.731 9.921c-.468-.316-.997-.55-1.64-.55-.964 0-1.84 1.104-2.811.937S1.98 8.73 2.577 8.2M7.497 5.623a2.343 2.343 0 1 0 0-4.686 2.343 2.343 0 0 0 0 4.686"
})));
export default SvgRecordAudio;